module.exports = __webpack_public_path__ + "img/data.c4264cfe.png";